import { Box, CardActions, Grid } from "@mui/material";
import Card from "@mui/material/Card";
import Skeleton from "@mui/material/Skeleton";
import "../setcard.css";

const SetSkeleton = ({ count, button, isCatalogNewCard = false, showButtons = true }) => {

  const catalogSkeleton = () => {
    return (
      <>
        <div className="top-side" style={{ display: "flex", width: "100%", height: "calc(100% - 50px)" }}>
          <div className="left-side" style={{ flex: 1, display: "flex", flexDirection: "column", gap: "8px", marginRight: "10px" }}>
            <div className="content" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Skeleton animation="wave" variant="circular" width={24} height={24} />
              <Skeleton animation="wave" variant="text" width={120} height={24} />
            </div>
            <div className="content-new" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Skeleton animation="wave" variant="circular" width={15} height={15} />
              <Skeleton animation="wave" variant="text" width={100} height={18} />
            </div>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              {[...Array(3)].map((_, index) => (
                <div className="content-new" key={index} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <Skeleton animation="wave" variant="circular" width={15} height={15} />
                  <Skeleton animation="wave" variant="text" width={40} height={18} />
                </div>
              ))}
            </div>
            <div className="content-new" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Skeleton animation="wave" variant="circular" width={15} height={15} />
              <Skeleton animation="wave" variant="text" width={80} height={18} />
            </div>
            <div className="content-new" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Skeleton animation="wave" variant="circular" width={15} height={15} />
              <Skeleton animation="wave" variant="text" width={80} height={18} />
            </div>
          </div>
          <div className="right-side" style={{ flex: 1 }}>
            <Grid container spacing={0.5} m={0} p={0}>
              {[...Array(4)].map((_, index) => {
                const row = Math.floor(index / 2);
                const col = index % 2;
                const paddingTop = row === 0 ? "0!important" : "inherit";
                const paddingLeft = col === 0 ? "0!important" : "inherit";

                return (
                  <Grid key={index} item sm={6} lg={6} sx={{ paddingTop, paddingLeft }}>
                    <Skeleton animation="wave" variant="rectangular" width="100%" height="92px" sx={{ borderRadius: "5px" }} />
                  </Grid>
                );
              })}
            </Grid>
          </div>
        </div>

        {showButtons && (
          <CardActions
            className="button-side"
            sx={{ padding: "0px", width: "100%", display: "flex", justifyContent: "space-between", nalignItems: "center", marginTop: "auto", height: "40px" }}
          >
            <div style={{ display: "flex", gap: "10px", flex: 1 }}>
              <Skeleton animation="wave" variant="rectangular" width={200} height={36} sx={{ borderRadius: "4px" }} />
              <Skeleton animation="wave" variant="rectangular" width={150} height={36} sx={{ borderRadius: "4px" }} />
            </div>
            <Skeleton animation="wave" variant="circular" width={24} height={24} />
          </CardActions>
        )}
      </>
    )
  }
  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "30px", rowGap: "32px" }}
      style={{ padding: isCatalogNewCard ? "0px" : "10px", paddingTop: "10px" }}
    >
      {Array(count)
        .fill(0)
        .map((_, ind) => {
          return (
            <Grid item className="product" key={ind}>
              <div className={isCatalogNewCard ? "catalog-new-card" : "set-card"}>
                <Card
                  style={isCatalogNewCard ? {
                    padding: "10px", borderRadius: "10px", minWidth: "420px", maxWidth: "420px", maxHeight: "257px", minHeight: "257px", alignItems: "flex-start", border: "none", gap: "12px", flexDirection: "column", display: "flex"
                  } : { padding: "20px", borderRadius: "10px", minWidth: "480px", maxWidth: "480px", height: "270px", alignItems: "flex-start", display: "flex", justifyContent: "center" }}
                >
                  {/* For Catalog New Card */}
                  {isCatalogNewCard ? (
                    <>
                      {catalogSkeleton()}
                    </>
                  ) : (
                    <>
                      <div className="left-side">
                        {
                          button ? (
                            <>
                              {/* <div className="content">
                          <Skeleton animation="wave" variant="text" width={120} height={30} />
                        </div> */}
                              {[...Array(5)].map((_, index) => (
                                <div className="content" key={index}>
                                  <Skeleton animation="wave" variant="circular" width={24} height={24} />
                                  <Skeleton animation="wave" variant="text" width={120} height={20} />
                                </div>
                              ))}
                            </>
                          ) : (
                            [...Array(5)].map((_, index) => (
                              <div className="content" key={index}>
                                <Skeleton animation="wave" variant="circular" width={24} height={24} />
                                <Skeleton animation="wave" variant="text" width={120} height={20} />
                              </div>
                            ))
                          )}
                      </div>

                      <div className="right-side">
                        <Grid container spacing={0.5} m={0} p={0}>
                          {[...Array(4)].map((_, index) => {
                            const row = Math.floor(index / 2);
                            const col = index % 2;
                            const paddingTop = row === 0 ? "0!important" : "inherit";
                            const paddingLeft = col === 0 ? "0!important" : "inherit";

                            return (
                              <Grid
                                key={index}
                                item
                                sm={6}
                                lg={6}
                                sx={{
                                  width: "114px",
                                  height: button ? "90px" : "114px",
                                  paddingTop,
                                  paddingLeft,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "start",
                                }}
                              >
                                <Skeleton animation="wave" variant="square" width={button ? 120 : 120} height={button ? 85 : 110} sx={{ borderRadius: "5px" }} />
                              </Grid>
                            );
                          })}

                          {button && (
                            <Box
                              sx={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                marginTop: "0px",
                                gap: "10px",
                              }}
                            >
                              <div>
                                <Skeleton animation="wave" variant="text" width={100} height={45} />
                              </div>
                              <div>
                                <Skeleton animation="wave" variant="text" width={100} height={45} />
                              </div>
                            </Box>
                          )}
                        </Grid>
                      </div>
                    </>
                  )
                  }
                </Card>
              </div >
            </Grid >
          );
        })}
    </Grid >
  );
};

export default SetSkeleton;
